import { createSlice } from "@reduxjs/toolkit"

const initialState = {
  loading: false,
  deleting: false,
  error: null,
}

const manualSubscriptionSlice = createSlice({
  name: "manualSubscription",
  initialState,
  reducers: {
    update(state) {
      state.loading = true
      state.error = null
    },
    updateCompleted(state) {
      state.loading = false
    },
    updateRejected(state, action) {
      state.loading = false
      state.error = action.payload
    },
    remove(state) {
      state.deleting = true
      state.error = null
    },
    removeCompleted(state) {
      state.deleting = false
    },
    removeRejected(state, action) {
      state.deleting = false
      state.error = action.payload
    },
    cleanState() {
      return initialState
    },
  },
})
/**
 * @namespace
 * @property {function} update
 * @property {function} updateCompleted
 * @property {function} updateRejected
 * @property {function} remove
 * @property {function} removeCompleted
 * @property {function} removeRejected
 * @property {function} cleanState
 */
export const manualSubscription = manualSubscriptionSlice.actions

export const selectManualSubscription = state =>
  state.userAccounts.manualSubscription

export default manualSubscriptionSlice.reducer
